import PropTypes from 'prop-types';

export default PropTypes.shape({
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  gPlus: PropTypes.string,
  instagram: PropTypes.string,
});
